import {I18n} from '@aws-amplify/core';

import {formatTimestamp} from '../../../utils/TableTimestamps';
import {BankAccount} from '../types';

export const getColumns = (onRecordClick?: (record: BankAccount) => void) => [
    {
        title: I18n.get('Bank Account'),
        width: '1fr',
        render: (item: BankAccount) => onRecordClick ? (
            <span
                style={{color: 'var(--mantine-color-blue-6)', cursor: 'pointer'}}
                onClick={() => onRecordClick(item)}
            >
                {item.id}
            </span>
        ) : item.id,
    },
    {
        title: I18n.get('Account Holder'),
        width: '1fr',
        render: (item: BankAccount) => item.accountHolderName,
    },
    {
        title: I18n.get('Bank'),
        width: '1fr',
        render: (item: BankAccount) => item.bankName,
    },
    {
        title: I18n.get('Created'),
        width: '1fr',
        render: (item: BankAccount) => formatTimestamp(item.created as string),
    },
];

// Keep backward-compatible export for any remaining consumers
export const columns = getColumns();
